/** Temporary site-header flag only. Routes, CMS, data, and /portfolio URLs stay live. Set true to restore the menu. */
export const SHOW_PORTFOLIO_IN_SITE_NAV = false;

export const PUBLIC_NAV = [
  { en: "About Us", ko: "회사소개", page: "/about" },
  { en: "Portfolio", ko: "포트폴리오", page: "/portfolio" },
  { en: "Work", ko: "사업 영역", page: "/about", sectionId: "services" },
  { en: "Services", ko: "서비스", page: "/services" },
  { en: "Capabilities", ko: "역량", page: "/capabilities" },
  { en: "Guide", ko: "가이드", page: "/guides" },
  { en: "Contact", ko: "상담 신청", action: "contact", page: "/#contact" },
];

export function publicNavTo(item) {
  if (!item?.sectionId) return item?.page || "/";
  return `${item.page}#${item.sectionId}`;
}

export function visibleSiteNav() {
  if (SHOW_PORTFOLIO_IN_SITE_NAV) return PUBLIC_NAV;
  return PUBLIC_NAV.filter((item) => item.page !== "/portfolio");
}

export const FOOTER_SERVICE_LINKS = [
  { label: "홈페이지 제작", href: "/services/homepage" },
  { label: "병원 홈페이지", href: "/services/hospital" },
  { label: "웹 프로그램", href: "/services/web-app" },
  { label: "관리자 / CMS", href: "/services/admin-cms" },
  { label: "AI 솔루션", href: "/services/ai" },
  { label: "업무 자동화", href: "/services/automation" },
  { label: "SaaS", href: "/services/saas" },
  { label: "SEO · AEO · GEO", href: "/services/search" },
];

export const FOOTER_EXPLORE_LINKS = [
  { label: "회사소개", href: "/about" },
  { label: "서비스", href: "/services" },
  { label: "역량", href: "/capabilities" },
  { label: "가이드", href: "/guides" },
  { label: "포트폴리오", href: "/portfolio" },
  { label: "FAQ", href: "/about#faq" },
];

export const SERVICE_CARD_HREFS = {
  corporate: "/services/homepage",
  platform: "/services/web-app",
  edu: "/services/saas",
  cms: "/services/admin-cms",
  ai: "/services/ai",
  uiux: "/services/homepage",
  seo: "/services/search",
  ops: "/services/web-app",
};
